// iter937 — Standardized on the shared <BranchMultiSelect> + <DateQuickFilter>
// (Global Standardization Phase 2) so the dashboard matches Sales, Invoices,
// Reversals, GL and Trial Balance.
//
// Backwards-compat: `onBranchChange` still receives an array (dashboard stats
// queries send `branch_ids` CSV). `onDateChange` still emits
// `{start, end, start_date, end_date, start_obj, end_obj, period}`.
import { useEffect } from 'react';
import ShareViewButton from '@/components/common/ShareViewButton';
import { useBranchStore } from '@/stores';
import { BranchMultiSelect } from '@/components/BranchMultiSelect';
import { DateQuickFilter } from '@/components/DateQuickFilter';

export function DashboardFilterBar({
  branchFilter,
  dateFilter,
  compareEnabled,
  onBranchChange,
  onDateChange,
}) {
  const branches = useBranchStore((s) => s.branches);
  const fetchBranches = useBranchStore((s) => s.fetchBranches);
  useEffect(() => {
    if (!branches || branches.length === 0) fetchBranches?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selected = Array.isArray(branchFilter) ? branchFilter : [];
  const handleDate = (r) => {
    const start = r?.start || null;
    const end = r?.end || null;
    const startObj = start ? new Date(start) : null;
    const endObj = end ? new Date(end + 'T23:59:59') : null;
    onDateChange({
      start,
      end,
      start_date: start,
      end_date: end,
      start_obj: startObj,
      end_obj: endObj,
      period: start && end ? 'custom' : 'all',
    });
  };

  return (
    <div className="flex gap-3 items-center flex-wrap" data-testid="dashboard-filter-bar">
      <BranchMultiSelect
        value={selected}
        onChange={onBranchChange}
        branches={branches}
        width="w-48"
        testid="dashboard-branch-filter"
      />
      <DateQuickFilter onFilterChange={handleDate} testid="dashboard-date-filter" />
      <ShareViewButton
        params={{
          branch: selected.length === 1 ? selected[0] : null,
          from: dateFilter?.start_date || dateFilter?.start || null,
          to: dateFilter?.end_date || dateFilter?.end || null,
          compare: compareEnabled ? '1' : null,
        }}
      />
    </div>
  );
}

export default DashboardFilterBar;
